/* src/app/modules/dna-syngovia/components/dna-syngovia/dna-syngovia.component.scss */
:host {
  display: block;
  position: relative;
}
.tabs-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
sh-modal {
  position: absolute;
  z-index: 2;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;
}
api-call-gate {
  min-height: 24.1875rem;
  align-items: center;
}
/*# sourceMappingURL=dna-syngovia.component.css.map */
